import styled from '@emotion/styled'
import { tokens } from '../../theme.js'

export const LoginLayout = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background: ${tokens.colors.background.light};
  padding: 70px 10%;
  box-sizing: border-box;
  gap: 20%;
  @media (max-width: 760px) {
    flex-direction: column;
    align-items: center;
    gap: 28px;
    padding: 32px 20px;
  }
`
export const WelcomeSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  min-width: 280px;
  max-width: 360px;
  @media (max-width: 760px) {
    min-width: 0;
    width: 100%;
    max-width: 420px;
    align-items: center;
    text-align: center;
  }
`
export const BrandLogo = styled.div`
  height: 72px;
  & > img {
    display: block;
    width: auto;
    height: 100%;
  }
`
export const WelcomeHeading = styled.h1`
  font: 400 50px/1.1 ${tokens.fonts.heading};
  color: ${tokens.colors.text.heading};
  margin: 0;
  max-width: 350px;
`
export const LoginCard = styled.div`
  background: ${tokens.colors.white};
  border-radius: ${tokens.borderRadius.div};
  padding: 48px;
  width: 100%;
  max-width: 420px;
  border: 1px solid ${tokens.colors.sectionDivider};
  align-self: center;
  box-sizing: border-box;
  @media (max-width: 760px) {
    padding: 30px 24px;
  }
`
export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`
export const FormFieldLabel = styled.label`
  display: block;
  color: ${tokens.colors.text.body};
  font: 500 13px/18px ${tokens.fonts.body};
  text-align: left;
`
